module.exports = lib__moment.locale["zh-cn"];